<div class="login-bg"></div>

<div class="login-page">
  <div class="login-card">
    <div class="login-logo">
      <img src="assets/images/robuschi-logo.png" alt="Robuschi" />
    </div>

    <h2 class="login-title">{{ 'LOGIN.SIGN_IN' | translate }}</h2>
    <p class="login-subtitle">{{ 'LOGIN.SUBTITLE' | translate }}</p>

    <form [formGroup]="loginForm" (ngSubmit)="logIn()">
      <div class="field-group">
        <label for="username">{{ 'LOGIN.USER' | translate }}</label>
        <input
          id="username"
          type="text"
          formControlName="username"
          [placeholder]="'LOGIN.USERNAME_PLACEHOLDER' | translate"
          [class.invalid]="usernameCtrl?.invalid && usernameCtrl?.touched"
          [readonly]="loggingIn" />
        <span class="field-error" *ngIf="usernameCtrl?.invalid && usernameCtrl?.touched">
          {{ 'LOGIN.USERNAME_REQUIRED' | translate }}
        </span>
      </div>

      <div class="field-group">
        <label for="password">{{ 'LOGIN.PASS' | translate }}</label>
        <div class="password-wrap">
          <input
            id="password"
            [type]="passwordVisible ? 'text' : 'password'"
            formControlName="password"
            [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
            [class.invalid]="passwordCtrl?.invalid && passwordCtrl?.touched"
            [readonly]="loggingIn" />
          <button
            type="button"
            class="eye-btn"
            (click)="togglePassword()"
            tabindex="-1"
            title="Toggle password visibility"
            [attr.aria-label]="passwordVisible ? ('LOGIN.HIDE_PASSWORD' | translate) : ('LOGIN.SHOW_PASSWORD' | translate)">
            <!-- eye with slash: password is hidden (bullets) -->
            <svg
              *ngIf="!passwordVisible"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <line x1="3" y1="3" x2="21" y2="21" />
              <path d="M10.58 10.58A3 3 0 0 0 14.83 14.83" />
              <path d="M9.36 5.37A10.07 10.07 0 0 1 12 5c6.4 0 10 7 10 7a18.68 18.68 0 0 1-2.94 3.94" />
              <path d="M6.06 6.06A18.68 18.68 0 0 0 2 12s3.6 7 10 7a10.07 10.07 0 0 0 5.63-1.63" />
            </svg>
            <!-- eye open: password is visible as text -->
            <svg
              *ngIf="passwordVisible"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          </button>
        </div>
        <span class="field-error" *ngIf="passwordCtrl?.invalid && passwordCtrl?.touched">
          {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
        </span>
      </div>

      <div class="remember-row">
        <label class="remember-label">
          <input type="checkbox" formControlName="rememberMe" />
          <span>{{ 'LOGIN.REMEMBER_ME' | translate }}</span>
        </label>
      </div>

      <div class="login-error" *ngIf="errorMessage">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        {{ errorMessage }}
      </div>

      <button type="submit" class="login-btn" [disabled]="loggingIn">
        {{ loggingIn ? ('LOGIN.SIGNING_IN' | translate) : ('LOGIN.SIGN_IN' | translate) }}
      </button>
    </form>

    <p class="request-access">
      {{ 'LOGIN.NO_ACCESS' | translate }}
      <a class="request-access-link" [href]="requestAccessHref">{{ 'LOGIN.REQUEST_ACCESS' | translate }}</a>
    </p>
  </div>
</div>
